import { Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import Env from '@ridango/core/env';
import { TranslateService } from '@ngx-translate/core';
import { ApplicationFacade } from '@ridango/components';

@Component({
    templateUrl: './account-change-password-page.component.html',
    styleUrls: ['./account-change-password-page.component.scss']
})
export class AccountChangePasswordPageComponent {
    assetsPath$ = this.applicationFacade.assetsPath$;

    constructor(
        @Inject('ENV') public env: Env,
        private translate: TranslateService,
        private router: Router,
        private applicationFacade: ApplicationFacade
    ) {}

    back() {
        this.router.navigate([this.translate.currentLang, 'account', 'profile']);
    }

    handleSaveSuccess() {
        this.router.navigate([this.translate.currentLang, 'account', 'profile']);
    }
}
